export const CardPointeRpaModuleName = {
    CARDPOINTE_IPG: 'cardpointe-ipg' as const,
} as const;

export type CardPointeRpaModuleName =
    (typeof CardPointeRpaModuleName)[keyof typeof CardPointeRpaModuleName];
